import React, { Component} from 'react';
import TwoCol from "../../containers/twoCol";
import FlexText from "../../flexText";
import ThreeCol from "../../containers/threeCol";
import CircleHead from "../../circleHead";
import Vars from '../../config/vars';

class CircleBlock extends Component {
  returnCircles(){
    const size=((window.innerWidth*.5)*.33)*.288+"px";
    return this.props.rowData.map((circle, index) => (
      <ThreeCol className="circleBlock" key={index} style={{textAlign:"center",lineBreak:"word",display:"inline-flex"}}>
        <CircleHead image={circle.field_image.uri} size="{size}" className="circleBlockImage" styles={{
          margin:"auto",
          backgroundSize:size+" "+size,    
        }}/>
        {typeof circle.field_link_1!=="undefined"?(circle.field_link_1.title!==""?(
          <FlexText tabIndex="-1" color="#007155" tag="h3" max="20.8" min="17" styles={{textAlign:"center"}}>{circle.field_link_1.title}</FlexText>):null)
          :null }
        {typeof circle.field_link_1!=="undefined"?(
          <FlexText tabIndex="-1" tag="p" color="#888" max="17" min="14" styles={{textAlign:"center",fontFamily:"Roboto", textTransform:"none"}}>{circle.field_text_1}</FlexText>)
          :null }
      </ThreeCol>
    ));
  }  

  render() {
    return(
      <TwoCol minHeight="588px" padding= {"120px "+Vars.gutter+" 120px "+ Vars.gutter}>
        {this.returnCircles()}  
      </TwoCol>
    );
  }
}

export default CircleBlock;